import React, { useState, useRef } from "react";
import { Typography, Form, Card, Button, Row, Col, message } from 'antd'
import MultiSelector from './MultiSelector'
import PeriodRangePicker from './PeriodRangePicker'
import useVirtualDevices from '../hooks/useVirtualDevices'
import useElements from "../hooks/useElements";
import { apiFetch } from "../utils/api"
import { useDateRange } from '../hooks/useDateRange'
import dayjs from "dayjs";

const { Title } = Typography

export default function ConcentrationsView() {
  const { devices, loading: loadingDevices } = useVirtualDevices()
  const { elements, loading: loadingDeviceElements } = useElements([], true)

  const [selectedDevices, setSelectedDevices] = useState([])
  const [selectedElements, setSelectedElements] = useState([])
  const [loading, setLoading] = useState(false)

  const [customRange, setCustomRange] = useState({
    // from: dayjs().subtract(24, 'hour'),
    // to: dayjs(),
    from: dayjs().startOf('day'), // 24 horas previas, comenzando desde el minuto 0
    to: dayjs().endOf('day') 
  });
  const {
    showCustom,
    selectedLabel,
    setPreset,
    setShowCustom,
    selectedPreset,
    presetDefs,
  } = useDateRange(setCustomRange);

  const periodPickerRef = useRef()

  const normalize = (d) =>  d.set("second", 0).set("millisecond", 0);

  const runCalculation = async () => {

    if (selectedDevices.length === 0) {
      message.warning("Select at least one device")
      return
    }

    if (selectedElements.length === 0) {
      message.warning("Select at least one element")
      return
    }

    try {
      setLoading(true)

      const body = {
        deviceIds: selectedDevices,
        elementIds: selectedElements,
        from: normalize(customRange.from).format("YYYY-MM-DDTHH:mm"),
        to: normalize(customRange.to).format("YYYY-MM-DDTHH:mm"),
      }

      console.log("Sending payload:", body)

      const response = await apiFetch("/api/concentration/calculate", {
        method: "POST",
        body: JSON.stringify(body),
      })

      console.log("Backend response:", response)

      message.success("Calculation completed!")

    } catch (error) {
      console.error("Error:", error)
      message.error("Error running calculation")
    } finally {
      setLoading(false)
    }
  }

  const runAutoCalculation = async () => {
    try {
      setLoading(true)
      const response = await apiFetch("/api/concentration/manual", {
        method: "POST"
      })
      console.log("Backend response:", response)

      message.success("Calculation completed!")

    } catch (error) {
      console.error("Error:", error)
      message.error("Error running calculation")
    } finally {
      setLoading(false)
    }
  }

  return (
    <Card style={{ marginBottom: 16, border: 0, boxShadow: 'none', padding: 0 }}>
      <Title level={3}>Concentrations</Title>

      <Row gutter={16} align="bottom">

        {/* Devices */}
        <Col span={6}>
          <Form.Item
            label="Devices"
            style={{ minWidth: 250, marginBottom: '5px' }}
          >
            <MultiSelector
              items={devices}
              value={selectedDevices}
              onChange={setSelectedDevices}
              placeholder="Select devices"
              disabled={loadingDevices}
            />
          </Form.Item>
        </Col>

        {/* Elements */}
        <Col span={6}>
          <Form.Item
            label="Elements"
            style={{ minWidth: 250, marginBottom: '5px' }}
          >
            <MultiSelector
              items={elements}
              value={selectedElements}
              onChange={setSelectedElements}
              placeholder="Select elements"
              disabled={loadingDeviceElements}
            />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            label="Period"
            style={{ minWidth: 250, marginBottom: '5px' }}
          >
            <PeriodRangePicker
              ref={periodPickerRef}
              value={customRange}
              onChange={setCustomRange}
              showCustom={showCustom}
              setPreset={setPreset}
              setShowCustom={setShowCustom}
              selectedPreset={selectedPreset}
              selectedLabel={selectedLabel}
              presetDefs={presetDefs}
              // width="100%"
            />
          </Form.Item>
        </Col>

        {/* Button */}
        <Col span={6} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            type="primary"
            loading={loading}
            style={{ marginRight: 8 }}
            onClick={runCalculation}
          >
            Run
          </Button>
          <Button
            type="primary"
            loading={loading}
            onClick={runAutoCalculation}
          >
            Run Auto
          </Button>
        </Col>
      </Row>
    </Card>
  )
}
